/* ============================================================
   PAGE HEADER
   ============================================================ */

import { Box, Typography, Button } from "@material-ui/core";
import RefreshIcon from '@material-ui/icons/Refresh';
import GroupOutlinedIcon from '@material-ui/icons/GroupOutlined';

interface PageHeaderProps {
  loading: boolean;
  onRefresh: () => void;
}


export const PageHeader: React.FC<
  PageHeaderProps
> = ({
  loading,
  onRefresh,
}) => {

  return (
    <Box
      style={{
        height: 58,
        flexShrink: 0,
        padding:
          '0 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent:
          'space-between',
        background: '#FFFFFF',
        borderBottom:
          '1px solid #E5EAF1',
      }}
    >

      <Box
        display="flex"
        alignItems="center"
      >

        <Box
          style={{
            width: 36,
            height: 36,
            borderRadius: 8,
            marginRight: 10,
            display: 'flex',
            alignItems:
              'center',
            justifyContent:
              'center',
            background:
              'linear-gradient(135deg, #2563EB, #3B82F6)',
            boxShadow:
              '0 3px 8px rgba(37, 99, 235, 0.20)',
          }}
        >

          <GroupOutlinedIcon
            style={{
              color: '#FFFFFF',
              fontSize: 21,
            }}
          />

        </Box>


        <Box>

          <Typography
            style={{
              fontSize: 18,
              lineHeight: 1.1,
              fontWeight: 700,
              color: '#111827',
            }}
          >
            Duplicate Spotter
          </Typography>

          <Typography
            style={{
              marginTop: 3,
              fontSize: 12,
              color: '#94A3B8',
            }}
          >
            Review and resolve potential
            content duplicates
          </Typography>

        </Box>

      </Box>


      <Button
        variant="outlined"
        size="small"
        startIcon={
          <RefreshIcon />
        }
        disabled={loading}
        onClick={onRefresh}
        style={{
          height: 32,
          minWidth: 92,
          borderColor:
            '#2563EB',
          color:
            '#2563EB',
          textTransform:
            'none',
          fontSize: 11,
          fontWeight: 600,
          borderRadius: 6,
        }}
      >
        Refresh
      </Button>

    </Box>
  );
};